import { FullStory, init as initFullStory } from '@fullstory/browser';

import { environment } from 'src/common/environment';

const isFullStoryDisabled = !environment.fullStory.orgId;
const isFullStoryDevMode = !environment.isProd && !environment.isStaging && !environment.isDev;

class ExternalLogger {
  public initialize(): void {
    if (isFullStoryDisabled) {
      console.warn('Full Story is disabled');

      return;
    }

    initFullStory({
      orgId: environment.fullStory.orgId,
      devMode: isFullStoryDevMode,
    });
  }

  public setUser(user: { id: string } | null): void {
    if (isFullStoryDisabled) {
      return;
    }

    FullStory('setIdentity', {
      anonymous: !user,
      uid: user?.id,
    });
  }
}

export const externalLogger = new ExternalLogger();
